import comp from "./VoiceRecorder";
export default comp;
